// Function that builds Choices
const select_args = {
    allowHTML: true,
    itemSelectText: '',
    searchEnabled: false,
}

let row_brand_filter_element = document.querySelector('#row-brand-filter');
let row_type_filter_element = document.querySelector('#row-type-filter');
let content_brand_filter_element = document.querySelector('#content-brand-filter');
let content_type_filter_element = document.querySelector('#content-type-filter');

if (typeof(row_brand_filter_element) != 'undefined' && row_brand_filter_element != null) {
    var row_brand_filter_choices = new Choices(row_brand_filter_element, select_args);

    row_brand_filter_choices.passedElement.element.addEventListener(
        'change',
        function(event) {
          // do something creative here...
          console.log(event.detail.value);
          content_brand_filter_choices.setChoiceByValue(event.detail.value);
        },
        false,
    );
}

if (typeof(row_type_filter_element) != 'undefined' && row_type_filter_element != null) {
    var row_type_filter_choices = new Choices(row_type_filter_element, select_args);

    row_type_filter_choices.passedElement.element.addEventListener(
        'change',
        function(event) {
          // do something creative here...
          console.log(event.detail.value);
          content_type_filter_choices.setChoiceByValue(event.detail.value);
        },
        false,
    );
}

if (typeof(content_brand_filter_element) != 'undefined' && content_brand_filter_element != null) {
    var content_brand_filter_choices = new Choices(content_brand_filter_element, select_args);

    content_brand_filter_choices.passedElement.element.addEventListener(
        'change',
        function(event) {
          // do something creative here...
          console.log(event.detail.value);
          row_brand_filter_choices.setChoiceByValue(event.detail.value);
        },
        false,
    );
}

if (typeof(content_type_filter_element) != 'undefined' && content_type_filter_element != null) {
    var content_type_filter_choices = new Choices(content_type_filter_element, select_args);

    content_type_filter_choices.passedElement.element.addEventListener(
        'change',
        function(event) {
          // do something creative here...
          console.log(event.detail.value);
          row_type_filter_choices.setChoiceByValue(event.detail.value);
        },
        false,
    );
}